export default __webpack_public_path__ + "static/media/welcome_icon.ff28e119.png";